module.exports = __webpack_public_path__ + "static/media/chevron-double-up.4f574412.svg";